<template>
  <body id="poster">
  <el-form class="login-container" label-position="left"
           label-width="0px">
    <h3 class="login_title">获取广告线索demo</h3>

  <!--    <el-form-item>-->
  <!--      <el-input type="text" v-model="loginForm.password"-->
  <!--                auto-complete="off" placeholder="输入导出文件名"></el-input>-->
  <!--    </el-form-item>-->
    <h4 class="login_title">查询时间格式：2022-7-18 00:00:00</h4>

    <el-form-item>



      <el-date-picker
        v-model="loginForm.timeStart"
        type="datetime"
        format="yyyy-MM-dd HH:mm:ss"
        value-format="yyyy-MM-dd HH:mm:ss"
        placeholder="开始日期">
      </el-date-picker>


    </el-form-item>
    <el-form-item>

      <el-date-picker
        v-model="loginForm.timeEnd"
        type="datetime"
        format="yyyy-MM-dd HH:mm:ss"
        value-format="yyyy-MM-dd HH:mm:ss"
        placeholder="结束日期">
      </el-date-picker>
    </el-form-item>
    <el-form-item style="width: 100%">
      <div>
<!--        <el-button class="btn-upload" type="primary" @click="handleUpdate">上传开户信息</el-button>-->
        <el-dialog
          title="提示"
          :visible.sync="dialogVisible"
          width="30%"
        >
			<span>
				<el-upload class="upload-demo"
                   ref="upload"
                   drag
                   action="https://test.nbweiou.cn/upload"
                   multiple
                   :auto-upload="false"
                   :limit="5"
                   :on-success="handleFilUploadSuccess"
                   :on-remove="handleRemove"
        >
					<i class="el-icon-upload"></i>
					<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
					<div class="el-upload__tip" slot="tip">只能上传txt文件，且不超过500kb</div>
				</el-upload>
			</span>
          <span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="handleUpload">确 定</el-button>
			</span>
        </el-dialog>
        <div>

        </div>
      </div>      <br>

      <el-button type="primary" style="width: 90%;background: #505458;border: none" v-on:click="useradd">导出广告线索</el-button>


    </el-form-item>
  </el-form>
  </body>
</template>

<script>

export default {
  name: 'index',
  data () {

    return {
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      dialogVisible: false,

      loginForm: {
        username: '',
        password: '',
        timeStart:'',
        timeEnd:'',
      },
      message:'1'
    }
  },
  methods: {
    chooseTimeRange(value1){
      this.time = parseInt(new Date().getTime()) + '';
      console.log(this.time)
      this.value2=value1;

    },
    handleRemove(file,fileList) {
      console.log(file,fileList);
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    // 文件上传成功时的函数
    handleFilUploadSuccess (res,file,fileList) {
      console.log(res,file,fileList)
      this.$message.success("上传成功")
    },
    handleUpdate () {
      this.dialogVisible = true;
    },
    // 处理文件上传的函数
    handleUpload () {
      // console.log(res,file)
      this.submitUpload()
      this.dialogVisible = false
    },


    useradd () {
      this.$message.success("正在导出请稍等.....")

      this.$axios.get('https://test.nbweiou.cn/get_gg?token='+this.loginForm.username+'&name='+this.loginForm.password+'&startTime='+this.loginForm.timeStart
        +'&endTime='+this.loginForm.timeEnd

      ).then (
        successResponse =>{
          if (successResponse.data==true){
            this.$message.success("导出成功！")
            window.location.href="https://test.nbweiou.cn/getFile"

          }else {
            this.$message.error("导入失败")
          }
        }
      )



    },

  }
}
</script>
<style>
.login-container {
  border-radius: 15px;
  background-clip: padding-box;
  margin: 90px auto;
  width: 350px;
  padding: 35px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
}
#poster {
  background-position: center;
  height: 100%;
  width: 100%;
  background-size: cover;
  position: fixed;
}
body{
  margin: 0px;
}
.login_title {
  margin: 0px auto 40px auto;
  text-align: center;
  color: #505458;
}

</style>
<style scoped="scoped">
.btn-upload {
  z-index: 100;
  border-radius: 30px;
  box-shadow: 0 2px 12px 0 rgba(91, 156, 255, 0.9)
}

.el-upload {
  margin: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue